import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { METHOD } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

export const Method = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const h = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  return (
    <section id="metodo" className="grain relative overflow-hidden bg-[#1238CE] py-20 text-white lg:py-32" data-testid="method-section">
      <Container className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Overline dark>O método</Overline>
            <MaskText className="font-display mt-6 text-4xl font-bold leading-[1] tracking-[-0.035em] sm:text-6xl"
              lines={["Estratégia com", <span className="text-[#CCFF00]">direção.</span>, "Execução com", <span className="text-[#CCFF00]">método.</span>]} />
            <Reveal><p className="mt-6 max-w-sm text-base leading-relaxed text-white/85">A união entre um plano bem estruturado e uma execução eficiente é o que separa a intenção do resultado.</p></Reveal>
          </div>
        </div>
        <div ref={ref} className="relative lg:col-span-7">
          <div className="absolute bottom-0 left-[19px] top-0 w-px bg-white/20" />
          <motion.div style={{ height: h }} className="absolute left-[19px] top-0 w-px bg-[#CCFF00]" />
          {METHOD.map((m, i) => (
            <Reveal key={m.t} className="relative flex gap-6 pb-12 last:pb-0 sm:gap-8" data-testid={`method-step-${i}`}>
              <span className="font-mono-x relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full bg-[#CCFF00] text-xs font-medium text-[#060B19]">0{i + 1}</span>
              <div className="pt-1">
                <h3 className="font-display text-3xl font-bold tracking-[-0.02em] sm:text-4xl">{m.t}</h3>
                <p className="mt-2 max-w-md text-base leading-relaxed text-white/85">{m.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Container>
      <Container className="mt-20 border-t border-white/20 pt-12 lg:mt-28">
        <MaskText className="font-display text-2xl font-semibold leading-[1.1] tracking-[-0.02em] sm:text-4xl lg:text-5xl"
          lines={["Estratégia sem execução é intenção.", <span className="text-[#CCFF00]">Execução sem indicadores é tentativa.</span>]} />
      </Container>
    </section>
  );
};
